import React from 'react';
import classnames from 'classnames';
import Disrupt from '@ux/disrupt';
import Dialog from '@ux/dialog';
import { transform } from './legacy';

const UX_MODAL_CLASSNAME = 'ux-modal';

function Modal(props) {
  const {
    children,
    className,
    onClose,
    onEventBehind,
    portalElem,
    stretch,
    strategy,
    show,
    ...dialogProps
  } = props;

  if (typeof show !== 'undefined' && !show) return null;

  if (!portalElem && (typeof document === 'undefined' || !document.body)) return null;

  return (
    <Disrupt
      portalElem={ portalElem || document.body }
      strategy={ strategy || 'fixed' }
      onClose={ onClose }
      onEventBehind={ onEventBehind }
      stretch={ stretch }>
      <Dialog
        aria-modal={ true }
        role='dialog'
        className={ classnames(UX_MODAL_CLASSNAME, className) }
        onClose={ onClose }
        { ...transform(dialogProps) }>
        { children }
      </Dialog>
    </Disrupt>
  );
}

Modal.propTypes = { ...Disrupt.propTypes, ...Dialog.propTypes };

export default Modal;
